import {Button} from 'platform/components';
import {Box, Hide, HStack, Icon, Show, Spinner, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface AdUpdateAlertProps extends TestIdProps {
  isUpdating: boolean;
  onUpdate: () => void;
}

export function AdUpdateAlert(props: AdUpdateAlertProps) {
  return (
    <Box
      backgroundColor="palettes.orange.10.100"
      borderColor="palettes.orange.30.100"
      borderTop="1px solid"
      borderRight="1px solid"
      borderBottom="1px solid"
      role="alert"
      data-testid={suffixTestId('alertWrapper', props)}
    >
      <Box padding={3} borderColor="severity.warning" borderLeft="3px solid">
        <HStack spacing={3} align="center" justify="space-between">
          <HStack spacing={3} align="center">
            <Hide when={props.isUpdating}>
              <Icon
                value="alert/warning"
                size={5}
                color="severity.warning"
                data-testid={suffixTestId('alertIcon', props)}
              />
            </Hide>
            <Show when={props.isUpdating}>
              <Spinner size="small" />
            </Show>
            <Text size="small" data-testid={suffixTestId('alertDescription', props)}>
              {i18n.t('entity.vehicle.labels.infoChangedUpdateClassifiedsQuestion')}
            </Text>
          </HStack>
          <Button
            title={i18n.t('general.actions.update')}
            onClick={props.onUpdate}
            isDisabled={props.isUpdating}
            data-testid={suffixTestId('updateButton', props)}
          />
        </HStack>
      </Box>
    </Box>
  );
}
